import { NgModule } from '@angular/core';
import { SharedModule } from 'lib-trend-core';
import { CardRadarComponent } from './card-radar.component';

/** The radar is read on the board AND in the attendance panel: declared once, exported to both. */
@NgModule({
  imports: [SharedModule],
  declarations: [CardRadarComponent],
  exports: [CardRadarComponent],
})
export class CardRadarModule { }
